import { db, storage } from "../firebase";
import {
  collection,
  doc,
  setDoc,
  updateDoc,
  deleteDoc,
  getDocs,
  serverTimestamp,
} from "firebase/firestore";
import {
  ref,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { uploadOptimizedImage } from "@/lib/uploadImage";
import { sortByOrder } from "./reorderService";

const FERRIES_COLLECTION = "ferries";

/** Generates a fresh id for a new ferry draft — reused across image
 * upload + final submit, same pattern as generatePackageId/generateGatewayId. */
export function generateFerryId() {
  return doc(collection(db, FERRIES_COLLECTION)).id;
}

export async function createFerry(id, payload) {
  await setDoc(doc(db, FERRIES_COLLECTION, id), {
    ...payload,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return id;
}

export async function updateFerry(id, payload) {
  await updateDoc(doc(db, FERRIES_COLLECTION, id), {
    ...payload,
    updatedAt: serverTimestamp(),
  });
  return id;
}

export async function deleteFerry(id, imageUrl) {
  await deleteDoc(doc(db, FERRIES_COLLECTION, id));
  if (imageUrl) {
    try {
      await deleteObject(ref(storage, imageUrl));
    } catch (err) {
      // Image may already be gone or URL may not be a storage ref
      // (e.g. external URL) — don't block the delete on cleanup failing.
      console.warn("Ferry image cleanup failed:", err);
    }
  }
}

export async function getAllFerries() {
  const snap = await getDocs(collection(db, FERRIES_COLLECTION));
  const items = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  return sortByOrder(items);
}

/** Uploads/replaces the hero image for a ferry. If replacing, the old
 * image at existingUrl is deleted after the new one succeeds. */
export async function uploadFerryImage(id, file, existingUrl) {
  const storageRef = ref(
    storage,
    `ferries/${id}/${Date.now()}_${file.name}`,
  );
  const snap = await uploadOptimizedImage(storageRef, file);
  const url = await getDownloadURL(snap.ref);

  if (existingUrl) {
    try {
      await deleteObject(ref(storage, existingUrl));
    } catch (err) {
      console.warn("Old ferry image cleanup failed:", err);
    }
  }

  return url;
}